
define('include/requirejs-text/text!modules/Lists/views/List_Item_View.html',[],function () { return '<!-- listitem-template -->\n<script type="text/x-underscore" id=\'list-template\'>\n    <article id="all">\n        <span id="select" class="fa fa-film fa-fw"/>\n        <input id="name" type="text" value="<%=model.get(\'name\')%>" readonly>\n        <span id="erase" class="fa fa-close fa-fw"/>\n    </article>\n</script>\n<!-- end -->\n';});

define('include/require-css/css!modules/Lists/views/List_Item_View',[],function(){});
/*
 * @Copyright (C) 2016-01-04 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */
 
define('modules/Lists/views/List_Item_View',[
    'jquery',
    'underscore',
    'backbone',
    'include/requirejs-text/text!./List_Item_View.html',
    'include/require-css/css!./List_Item_View.css',
], function($, _, Backbone, Template) {

    /**
     * @class List_Item_View
     *
     * Backbone.View
     * Carga una ventana para interactuar con la lista
     */
     
    var List_Item_View = Backbone.View.extend({
        model: null,
        tagName: 'li',
        appmodel: null,
        template: null,
        className: 'list_item',
        
        /**
         * List_Item_View::wrapper
         * Optiones para graficar la vista
         */
        
        wrapper: {
            html    : Template,
            name    : '#list-template'
        },
        
        /**
         * List_Item_View::events
         * Objeto de los eventos para la vista
         */
         
        events: {
            'click #erase'      : 'destroy',
            'click #select'     : 'select',
            'change #name'      : 'rename',
            'dblclick #name'    : 'writer',
        },
        
        /**
         * List_Item_View.initialize
         * Constructor de la ventana de Lista
         * @param <Object> attributes - Atributos de la vista
         * @param <App_Base_Model> appmodel - Modelo de la aplicacion
         */
         
        initialize: function(attributes, appmodel) {
            var self = this;
            void 0;
            self.appmodel = appmodel;
            self.template = self.appmodel.getTemplate(self.wrapper);
            self.model.on('select', self.onSelect, self);
            self.model.on('unselect', self.onUnselect, self);
            void 0;
        },
        
        /**
         * List_Item_View.render
         * Renderiza el modulo
         */
        
        render: function() {
            var self = this;
            void 0;
            self.$el.html(self.template(self));
            if(self.model.get('select')) {
                self.$el.addClass('list_active');
                self.model.trigger('select', self.model);
            }
            void 0;
        },
        
        /**
         * List_Item_View.destroy
         * Destruye la vista y restaura variables
         */
         
        destroy: function() {
            var self = this;
            void 0;
            self.model.destroy();
            self.remove();
            self.unbind();
            void 0;
        },
        
        /**
         * List_Item_View.rename
         * Renombra la lista
         */
         
        rename: function() {
            var self = this;
            void 0;
            var value = self.$('#name').val();
            self.model.save({'name': value}, {patch: true});
            void 0;
        },
        
        /**
         * List_Item_View.writer
         * Habilita la escritura en la lista
         */
         
        writer: function() {
            var self = this;
            void 0;
            self.$('#name').attr('readonly', false);
            void 0;
        },
        
        /**
         * List_Item_View.select
         * @brief Selecciona la lista
         */
        
        select: function() {
            var self = this;
            void 0;
            self.model.set({'select': true});
            void 0;
        },
        
        /**
         * List_Item_View.onSelect
         * Seleciona la lista probocando la cargade este
         * @private
         */
        
        onSelect: function() {
            var self = this;
            void 0;
            self.$el.addClass('list_active');
            self.model.save({'select': true});                   
            void 0;
        },
        
        /**
         * List_Item_View.onUnselect
         * Envia la vista como un/select
         * @private
         */
        
        onUnselect: function() {
            var self = this;
            void 0;
            self.$el.removeClass('list_active');
            self.model.save({'select': false}, {silent: true});      
            void 0;
        },
        
    });
    
    return List_Item_View;

});

define('include/requirejs-text/text!modules/Lists/views/Lists_Index_View.html',[],function () { return '<!-- list-template -->\n<script type="text/x-underscore" id=\'lists-template\'>\n    <div class="lists_view">\n        <div class="lists_content">\n            <div class="lists_header">\n                <span data-i18n="Lists.text.title"/>\n                <span id="close" class="fa fa-close fa-fw"/>\n            </div>\n            <ul class="lists_options">\n                <li>\n                    <article id="create">\n                        <span class="fa fa-plus fa-fw"/>\n                        <label data-i18n="Lists.text.plus"/>\n                    </article>\n                </li>\n            </ul>\n            <div class="lists_main">\n                <ul class="lists_core">\n                    <!-- listitem-template -->\n                </ul>\n            </div>\n        </div>\n        <div class="lists_arrow"/>\n    </div>\n</script>\n<!-- end -->\n';});

define('include/require-css/css!modules/Lists/views/Lists_Index_View',[],function(){});
/*
 * @Copyright (C) 2016-01-04 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */

define('modules/Lists/views/Lists_Index_View',[
    'jquery',
    'underscore',
    'backbone',
    './List_Item_View',
    '../collections/Lists_Models_Collection',
    'include/requirejs-text/text!./Lists_Index_View.html',
    'include/perfect-scrollbar/min/perfect-scrollbar.min',
    'include/require-css/css!include/perfect-scrollbar/min/perfect-scrollbar.min.css',
    'include/require-css/css!./Lists_Index_View.css',
], function(
        $,
        _,
        Backbone,
        List_Item_View,
        Lists_Models_Collection,
        Template
    ) {
    
    /**
     * @class Lists_Index_View
     *
     * Backbone.View
     * Carga una ventana para el manejo de listas del usuario
     *
     */
    
    var Lists_Index_View = Backbone.View.extend({
        TAG: 'Lists_Index_View',
        lists: [],
        appmodel: null,
        template: null,
        listmodels: null,
        
        /**
         * Lists_Index_View::wrapper
         * Optiones para graficar la vista
         */
        
        wrapper: {
            html: Template,
            class: 'lists_wrapper',
            parent: '.footer_head',
            style: 'display: none;'
        },
        
        /**
         * Lists_Index_View::events
         * Objeto de los eventos para la vista
         */
         
        events: {
            'click #close'      : 'hide',
            'click #create'     : 'create',
            'select.list.view'  : 'select',
        },
        
        /**
         * Lists_Index_View.initialize
         * Constructor de la ventana de Listas 
         * @param <Object> attributes - Atributos de la vista
         * @param <App_Record_Model> appmodel - Modelo de la aplicacion
         */
         
        initialize: function(attributes, appmodel) {
            var self = this;
            void 0;
            self.appmodel = appmodel;
            var wrapper = self.appmodel.getWrapper(self.wrapper);
            self.setElement(wrapper);
            var template = self.$("#lists-template").html();
            self.template = _.template(template);
            self.listmodels = new Lists_Models_Collection(null, {appmodel: self.appmodel});
            self.listmodels.on('add', self.onAdd, self);
            self.listmodels.on('select', self.select, self);
            self.listmodels.on('reset', self.onReset, self);
            // @note - se encarga de asegurar una unica lista donde select este en true
            self.listmodels.fetch({
                appmodel: self.appmodel,
                success: function(collection, response, options) {
                    if(self.listmodels.isEmpty()) {
                        self.listmodels.create({select: true}, {wait: true, appmodel: self.appmodel});
                    }
                    var listmodels = self.listmodels.where({select: true});
                    if(listmodels.length>1) {
                        listmodels[0].set({select: false}, {silent: true});
                        listmodels[0].set({select: true});
                    }
                }
            });
            void 0;
        },
        
        /**
         * Lists_Index_View.select
         * Cambia el modelo del footer con el nuevo 
         * @params <List_Record_Model> model - modelo para ser seleccionado
         */
        
        select: function(model) {
            var self = this;
            void 0;
            self.appmodel.getModule('Footer', function(footer) {
                footer.select(model);
            });
            void 0;
        },
        
        /**
         * Lists_Index_View.onReset
         * Es llamado cuando se resetea la lista y limpia el footer
         */
        
        onReset: function() {
            var self = this;
            void 0;
            self.appmodel.getModule('Footer', function(footer) {
                footer.clear();
            });
            void 0;
        },
        
        /**
         * Lists_Index_View.render
         * Renderiza el modulo
         */
        
        render: function() {
            var self = this;
            void 0;
            self.$el.html(self.template(self));
            self.$('[data-i18n]').i18n();
            self.$('[data-i18n]').tooltip({placement : 'bottom'});
            self.$('.lists_main').perfectScrollbar({suppressScrollX: true});
            void 0;
        },
        
        /**
         * Lists_Index_View.onAdd
         * Suma una lista a la vista
         * @params <List_Record_Model> model - modelo para ser seleccionado
         * @private
         */
        
        onAdd: function(model) {
            var self = this;
            void 0;
            var list = new List_Item_View({model:model}, self.appmodel);
            list.render();
            self.lists.push(list);
            self.$('.lists_core').append(list.el);
            void 0;
        },
        
        /**
         * Lists_Index_View.create
         * Crea una nueva lista a la vista pasando parametros al listmodel
         * @return <List_Record_Model> listmodel - modelo creado
         */
        
        create: function() {
            var self = this;
            void 0;
            var listmodel = self.listmodels.create({}, {appmodel: self.appmodel});
            void 0;
            return listmodel;
        },
        
        /**
         * Lists_Index_View.toggle
         * Esconde o presenta la vista de acuerdo al estado que este
         */
         
        toggle: function() {
            var self = this;
            void 0;
            if(!self.$('.lists_header').visible()) {
                self.show();
            } else {
                self.hide();
            }
            void 0;
        },
        
        /**
         * Lists_Index_View.show
         * Presenta la ventana de listas
         */
         
        show: function() {
            var self = this;
            void 0;
            self.$el.show();
            void 0;
        },
        
        /**
         * Lists_Index_View.hide
         * Esconde la ventana de listas
         */
         
        hide: function() {
            var self = this;
            void 0;
            self.$el.hide();
            void 0;
        },
        
    });
    
    return Lists_Index_View;
    
});

/*
 * @Copyright (C) 2016-01-03 by Yaggee
 *
 * https://www.yaggee.com
 * 
 * Yaggee es una plataforma de video stream, webrtc, socket.oi, odoo, requirejs ....
 * La meta es generar un video chat, para que cada persona pueda transmitir lo que desee
 * en el momento que lo desee.
 */

define('modules/Lists/__init__',[
    'jquery',
    'underscore',
    'backbone',
    './views/Lists_Index_View'
], function($, _, Backbone, Lists_Index_View) {
    
    return Lists_Index_View;
    
});

(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.list_item {\n    width: 100%;\n}\n\n.list_item #load {\n    float: left;\n}\n\n.list_item #name {\n    width: 70%;\n    border: 0px;\n    color: #DDDDDD;\n    background-color: inherit;\n}\n\n.list_item #erase {\n    float: right;\n}\n\n.list_active {\n    border: 1px solid #515151;\n    border-radius: 4px;\n}\n\n.list_active #name {\n    color: #FFB400;\n}\n.lists_wrapper {\n    margin-top: -250px;\n    font-family: Verdana, Geneva, sans-serif;\n    font-size: 12px;\n    float: right;\n}\n\n.lists_view {\n    position: absolute;\n}\n\n.lists_content {\n    width: 144px;\n    height: 250px;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    background-color: rgba(0,0,0,0.9);\n}\n\n.lists_header {\n    width: 100%;\n    color: #dddddd;\n    font-weight: bold;\n    text-align: center;\n    padding: 5px 0px;\n}\n\n.lists_header #close {\n    top: 7px;\n    right: 7px;\n    position: absolute;\n}\n\n.lists_content .lists_options {\n    width: 100%;\n    margin: 0px;\n    padding: 0px;\n    text-align: left;\n    list-style: none outside none;\n    border-top: 1px dotted #515151;\n    border-bottom: 1px dotted #515151;\n}\n\n.lists_content .lists_options article {\n    padding: 4px 0px 4px 3px;\n    color: #dddddd;\n}\n\n.lists_content .lists_options article:hover {\n    color: #ffb400;\n    background-color: #000;\n}\n\n.lists_content .lists_options span {\n    float: left;\n    margin-top: 3px;\n}\n\n.lists_content .lists_options label {\n    font-weight: normal;\n    margin: 0px;\n    margin-left: 15px;\n}\n\n.lists_main {\n    width: 100%;\n    height: 190px;\n    position: relative;\n    overflow: hidden;\n}\n\n.lists_core {\n    width: 95%;\n    float: left;\n    margin: 0px;\n    padding: 0px 1px;\n    list-style: none outside none;\n}\n\n.lists_content .lists_core article {\n    padding: 4px 0px 4px 3px;\n    color: #dddddd;\n}\n\n.lists_content .lists_core article:hover {\n    color: #ffb400;\n    background-color: #000;\n}\n\n.lists_content .lists_core span {\n    float: left;\n    margin-top: 3px;\n}\n\n.lists_content .lists_core input {\n    padding-left: 15px;\n}\n\n.lists_arrow {\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid rgba(0,0,0,0.9);\n    margin: 0px 0px 0px 45%;\n}\n');
